import { StatCardData } from '../types';

// Numbers Don't Lie Section Data
export const deadlinesFoldLeft: StatCardData[] = [
  {
    number: '250M',
    title: 'invoices uploaded',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873305_invoiceuploaded.svg',
    alt_text: 'invoiceuploaded',
  },
  {
    number: '6M',
    title: 'Businesses visible',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873294_businessvisible.svg',
    alt_text: 'businessvisible',
  },
  {
    number: '$300B',
    title: 'trade value filled',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873451_tradevaluefilled.svg',
    alt_text: 'tradevaluefilled',
  },
];

export const deadlinesFoldRight: StatCardData[] = [
  {
    number: '35,000',
    title: 'retail investors',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873368_retailinvestor.svg',
    alt_text: 'retailinvestor',
  },
  {
    number: '8M',
    title: 'tax returns filed',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873415_taxreturnfilled.svg',
    alt_text: 'taxreturnfilled',
  },
];
